const styles = {
  contanierGrid: {
    marginBottom: 2,
  },
  dateOfBirth: {
    width: '100%',
  },
  helperText: {
    ml: 1,
    mr: 1,
  },
  collapse: {
    pl: 1,
  },
};

export default styles;
